import { render, staticRenderFns } from "./LogoGobMonocromo.vue?vue&type=template&id=48be7d06&"
import script from "./LogoGobMonocromo.vue?vue&type=script&lang=js&"
export * from "./LogoGobMonocromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports